'use client';

import React from 'react';
import type { Product } from '@/lib/supabaseService';
import ProductCard from './ProductCard';

type CartItem = {
  productId: string;
  sizeId: string;
  quantity: number;
};

interface ProductGridProps {
  products: Product[];
  cart: CartItem[];
  onSizeSelect: (
    productId: string,
    productName: string,
    sizeId: string,
    sizeLabel: string,
    unitPrice: number
  ) => void;
  onQuantityChange: (productId: string, delta: number) => void;
}

export default function ProductGrid({
  products,
  cart,
  onSizeSelect,
  onQuantityChange,
}: ProductGridProps) {
  if (products.length === 0) {
    return (
      <section id="products" className="px-6 py-12 text-center">
        <p className="text-sm" style={{ color: 'var(--muted-foreground)' }}>
          No products available right now. Check back soon!
        </p>
      </section>
    );
  }

  return (
    <section id="products" className="px-4 py-8">
      <div className="divider-ornament mb-6 mx-4">
        <span className="text-xs font-serif font-semibold tracking-widest uppercase" style={{ color: 'var(--secondary)' }}>
          Our Snacks
        </span>
      </div>

      <div className="flex flex-col gap-4 max-w-xs mx-auto sm:max-w-xl sm:grid sm:grid-cols-2 lg:max-w-2xl lg:grid-cols-3">
        {products.map((product) => {
          const cartItem = cart.find((c) => c.productId === product.id);
          return (
            <ProductCard
              key={product.id}
              product={product}
              selectedSizeId={cartItem?.sizeId ?? null}
              quantity={cartItem?.quantity ?? 0}
              onSizeSelect={onSizeSelect}
              onQuantityChange={onQuantityChange}
            />
          );
        })}
      </div>
    </section>
  );
}